/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowUiAuthLogoutIcon24Regular = forwardRef('ArrowUiAuthLogoutIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M3.25 6A3.75 3.75 0 0 1 7 2.25h6a.75.75 0 0 1 0 1.5H7A2.25 2.25 0 0 0 4.75 6v12A2.25 2.25 0 0 0 7 20.25h6a.75.75 0 0 1 0 1.5H7A3.75 3.75 0 0 1 3.25 18V6Z" }),
        React.createElement("path", { d: "m20.275 12.752-3.641 3.642a.75.75 0 0 0 1.06 1.06l3.928-3.927a2.156 2.156 0 0 0 0-3.05L17.694 6.55a.75.75 0 0 0-1.06 1.06l3.641 3.642H9a.75.75 0 0 0 0 1.5h11.275Z" })));
});
